import { Router } from "express";

import { breakTimerController } from "../controllers/break-timer-controller";
import { authenticate, createRateLimit } from "../middleware/auth-middleware";
import { requireRole } from "../middleware/role-middleware";

const router = Router();

// Environment-aware rate limiting
const generalRateLimit = createRateLimit.general();

/**
 * Break Timer Routes (Student & Teacher)
 */

/**
 * @route   POST /api/v1/break/start
 * @desc    Start a break timer
 * @access  Private (Student, Teacher)
 */
router.post(
  "/break/start",
  authenticate,
  requireRole(["student", "teacher"]),
  generalRateLimit,
  (req, res) => breakTimerController.startBreak(req, res),
);

/**
 * @route   POST /api/v1/break/end
 * @desc    End/Return from break
 * @access  Private (Student, Teacher)
 */
router.post(
  "/break/end",
  authenticate,
  requireRole(["student", "teacher"]),
  generalRateLimit,
  (req, res) => breakTimerController.endBreak(req, res),
);

/**
 * @route   GET /api/v1/break/active
 * @desc    Get active break timer
 * @access  Private (Student, Teacher)
 */
router.get(
  "/break/active",
  authenticate,
  requireRole(["student", "teacher"]),
  generalRateLimit,
  (req, res) => breakTimerController.getActiveBreak(req, res),
);

/**
 * @route   GET /api/v1/break/history
 * @desc    Get break history
 * @access  Private (Student, Teacher)
 */
router.get(
  "/break/history",
  authenticate,
  requireRole(["student", "teacher"]),
  generalRateLimit,
  (req, res) => breakTimerController.getBreakHistory(req, res),
);

/**
 * Teacher Break Management Routes
 */

/**
 * @route   GET /api/v1/teacher/classes/:classId/breaks
 * @desc    Get student breaks for teacher's class
 * @access  Private (Teacher)
 */
router.get(
  "/teacher/classes/:classId/breaks",
  authenticate,
  requireRole(["teacher"]),
  generalRateLimit,
  (req, res) => breakTimerController.getClassBreaks(req, res),
);

/**
 * Student Break Management During Class Session
 * (Requires check-in; blocks after check-out; one active break at a time.)
 */

/**
 * @route   GET /api/v1/student/classes/:classId/breaks
 * @desc    Get break status for student in class (can start/finish, list of breaks, isOnBreak)
 * @access  Private (Student)
 */
router.get(
  "/student/classes/:classId/breaks",
  authenticate,
  requireRole(["student"]),
  generalRateLimit,
  (req, res) => breakTimerController.getStudentClassBreaks(req, res),
);

/**
 * @route   POST /api/v1/student/classes/:classId/breaks/start
 * @desc    Start a break (must be checked in, not checked out, no active break)
 * @access  Private (Student)
 */
router.post(
  "/student/classes/:classId/breaks/start",
  authenticate,
  requireRole(["student"]),
  generalRateLimit,
  (req, res) => breakTimerController.startStudentClassBreak(req, res),
);

/**
 * @route   POST /api/v1/student/classes/:classId/breaks/end
 * @desc    End current break (must be checked in, not checked out, currently on break)
 * @access  Private (Student)
 */
router.post(
  "/student/classes/:classId/breaks/end",
  authenticate,
  requireRole(["student"]),
  generalRateLimit,
  (req, res) => breakTimerController.endStudentClassBreak(req, res),
);

export default router;
